import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { m } from 'framer-motion';
import { Link as ScrollTo } from 'react-scroll';
import Buttons from '../../../Litho/Components/Button/Buttons';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';
import colors from '../../../constants/colors';

const IntroSection = () => {
	return (
		<section className='py-[130px] overflow-hidden lg:py-[90px] sm:py-[75px] xs:py-[50px]'>
			<Container>
				<Row className='items-center justify-center'>
					<Col lg={5} md={9} className='mb-[10px] md:mb-28'>
						<span className='font-serif mb-[20px] text-gradient bg-gradient-to-r from-[#bd3531] to-[#23262d] inline-block uppercase font-medium tracking-[1px]'>
							Road freight solutions
						</span>
						<h4 className='font-serif font-semibold text-darkgray w-[95%]'>
							We move cargo safely and on time
						</h4>
						<p className='w-[80%] mb-[25px] lg:w-[95%]'>
							From FTL to LTL, dedicated routes to spot capacity, we provide
							flexible trucking services across domestic and cross-border lanes.
						</p>
						<ScrollTo
							to='services'
							offset={0}
							delay={0}
							spy={true}
							smooth={true}
							duration={800}
						>
							<Buttons
								className='btn-flat mt-[15px] font-medium text-tprimary hover:text-black hover:bg-green-800 font-serif uppercase rounded-full md:mb-[15px]'
								icon='feather-arrow-right'
								iconPosition='after'
								themeColor={colors.tprimary}
								color={colors.tprimary}
								size='md'
								title='Contact Us'
							/>
						</ScrollTo>
					</Col>
					<Col
						lg={7}
						md={9}
						xs={12}
						className='px-[55px] md:pr-[50px] md:pl-[5px]'
					>
						<m.figure className='opacity-100 m-0 relative inline-block bg-gradient-to-r from-[#23262d] to-[#bd3531] rounded-lg w-100'>
							<m.img
								className='rounded-[6px] w-auto h-auto'
								src='/assets/img/services/road-freight.jpg'
								alt='road-freight'
								width='572.5'
								height='436.53'
								initial={{ opacity: 0, x: '0', y: '0' }}
								whileInView={{ opacity: 1, x: '-20px', y: '-20px' }}
								viewport={{ once: true }}
								transition={{ delay: 0.4, easing: 'linear' }}
							/>
							<m.span
								className='rounded-[6px] absolute top-0 left-0 w-full h-full -z-[1]'
								{...{ ...fadeIn, animate: { x: '35px', y: '5px' } }}
							></m.span>
						</m.figure>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default IntroSection;
